import { render, staticRenderFns } from "./InactivityScreen.vue?vue&type=template&id=910571b0&scoped=true"
import script from "./InactivityScreen.vue?vue&type=script&scoped=true&lang=js"
export * from "./InactivityScreen.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./InactivityScreen.vue?vue&type=style&index=0&id=910571b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910571b0",
  null
  
)

export default component.exports